/* Registering the worker, and only where it can actually work.
 *
 * A service worker needs a secure context. localhost counts; a plain-http LAN
 * address does not, which is exactly how the app is reached from a real
 * handset during development. So registration is attempted and its absence is
 * not treated as a failure: everything except offline shell caching works
 * without it, including the code, which is the part that has to survive a mall
 * basement.
 */
export function registerServiceWorker(): void {
  if (!("serviceWorker" in navigator)) return;
  if (!window.isSecureContext) {
    // Said out loud rather than silently skipped. "The service worker did not
    // register" is a thing worth knowing when testing offline behaviour on a
    // device, and the reason is never obvious.
    console.info(
      "[damga] service worker not registered: this origin is not a secure context. " +
        "Offline shell caching needs https or localhost.",
    );
    return;
  }
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js", { scope: "/" });
  });
}
